import { createFileRoute } from "@tanstack/react-router";
import { AdminDashboardShell } from "@/components/layout/AdminDashboardShell";
import { WebhookHealthPage } from "@/features/webhook-health";

export const Route = createFileRoute("/webhook-health/")({
  component: WebhookHealthRoute,
});

function WebhookHealthRoute() {
  return (
    <AdminDashboardShell>
      <WebhookHealthPage />
    </AdminDashboardShell>
  );
}
